<template>
  <el-dialog title="审核通知公告" :visible.sync="dialogVisible" width="70%" @closed="handleClose" append-to-body>
    <div class="audit-content">
      <!-- 通知类型 -->
      <div class="section">
        <div class="section-title">通知类型</div>
        <div class="section-content">
          <el-form label-width="120px" size="small">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="消息盒子">
                  <span>{{ currentRow.msgBox === 1 ? '是' : '否' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="push通知">
                  <span>{{ currentRow.isPushNotice === 1 ? '是' : '否' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="短信通知">
                  <span>{{ currentRow.isSmsNotice === 1 ? '是' : '否' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.isPushNotice === 1">
              <el-col :span="12">
                <el-form-item label="push模板ID">
                  <span>{{ currentRow.pushTemplateId || '-' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.isSmsNotice === 1">
              <el-col :span="12">
                <el-form-item label="短信模板ID">
                  <span>{{ currentRow.smsTemplateId || '-' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <!-- 消息盒子信息 -->
      <div class="section" v-if="currentRow.msgBox === 1">
        <div class="section-title">消息盒子信息</div>
        <div class="section-content">
          <el-form label-width="120px" size="small">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="消息标题">
                  <span>{{ currentRow.msgBoxTitle }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注">
                  <span>{{ currentRow.remark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="消息内容">
                  <span>{{ currentRow.msgBoxContent }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="事件类型">
                  <span>{{ getEventTypeName(currentRow.msgBoxEventType) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="事件响应">
                  <span>{{ currentRow.msgBoxEventBody || '-' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.msgBoxIconUrl || currentRow.msgBoxImageUrl">
              <el-col :span="12" v-if="currentRow.msgBoxIconUrl">
                <el-form-item label="icon">
                  <el-image :src="currentRow.msgBoxIconUrl" style="width: 80px; height: 80px;" fit="scale-down"></el-image>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="currentRow.msgBoxImageUrl">
                <el-form-item label="图片">
                  <el-image :src="currentRow.msgBoxImageUrl" style="width: 80px; height: 80px;" fit="scale-down"></el-image>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <!-- 命中配置 -->
      <div class="section">
        <div class="section-title">命中配置</div>
        <div class="section-content">
          <el-form label-width="120px" size="small">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="触发条件">
                  <span>{{ getTriggerConditionName(currentRow.activeMode) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="currentRow.daysAhead || currentRow.expireAdvanceDays">
                <el-form-item label="提前天数">
                  <span>{{ currentRow.daysAhead || currentRow.expireAdvanceDays }} 天</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="用户类型">
                  <span>{{ getAudienceTypeName(currentRow.audienceType) }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.userTags">
              <el-col :span="24">
                <el-form-item label="用户标签">
                  <span>{{ currentRow.userTags }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.accountImportKey">
              <el-col :span="24">
                <el-form-item label="指定账号">
                  <span>已导入文件</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.audienceType === 4">
              <el-col :span="24">
                <el-form-item label="客户端">
                  <span>{{ currentRow.isAllPlatform === 1 ? '全部端' : '指定端' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.platformType && currentRow.isAllPlatform === 0">
              <el-col :span="24">
                <el-form-item label="指定端">
                  <span>{{ getPlatformTypeNames(currentRow.platformType) }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.onceJobApplyTime">
              <el-col :span="12">
                <el-form-item label="发送时间">
                  <span>{{ currentRow.onceJobApplyTime }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentRow.periodJobStartTime || currentRow.periodJobEndTime">
              <el-col :span="12" v-if="currentRow.periodJobStartTime">
                <el-form-item label="开始时间">
                  <span>{{ currentRow.periodJobStartTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="currentRow.periodJobEndTime">
                <el-form-item label="结束时间">
                  <span>{{ currentRow.periodJobEndTime }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <!-- 发送配置 -->
      <div class="section">
        <div class="section-title">发送配置</div>
        <div class="section-content">
          <el-form label-width="120px" size="small">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="状态">
                  <span>{{ currentRow.status === 1 ? '上架' : '下架' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 审核意见 -->
    <div class="audit-opinion">
      <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="120px" size="small">
        <el-form-item label="审核意见" prop="content">
          <el-input
            type="textarea"
            :rows="3"
            v-model="auditForm.content"
            placeholder="请填写审核意见"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="danger" :loading="submitting" @click="handleReject">审核不通过</el-button>
      <el-button type="success" :loading="submitting" @click="handleApprove">审核通过</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { submitExamine } from '@/api/noticeManage/noticeManage'
import Message from "@/components/Message"

export default {
  name: 'AuditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentRow: {},
      auditForm: {
        content: ''
      },
      auditRules: {
        content: [
          { required: true, message: '请填写审核意见', trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (!val) {
        this.handleClose()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    // 显示审核弹窗
    show(row) {
      // 转换数据格式，与编辑弹窗保持一致
      this.fillCurrentRowFromData(row)
      console.log('currentRow', this.currentRow)
      this.auditForm.content = ''
      this.dialogVisible = true
    },

    // 从row数据填充显示数据（审核模式）
    fillCurrentRowFromData(row) {
      // 解析推送方式 pushType: "1,2,3"
      const typeList = (row.pushType || '')
        .split(',')
        .map(item => Number(item))
        .filter(item => [1, 2, 3].includes(item));

      this.currentRow = {
        id: row.id,
        msgBox: typeList.includes(1) ? 1 : 0,
        isPushNotice: typeList.includes(2) ? 1 : 0,
        isSmsNotice: typeList.includes(3) ? 1 : 0,
        pushType: row.pushType || '',
        pushTemplateId: row.pushTemplateId || '',
        smsTemplateId: row.smsTemplateId || '',
        msgBoxTitle: row.msgBoxTitle || '',
        remark: row.remark || '',
        msgBoxContent: row.msgBoxContent || '',
        jumpLink: row.jumpLink || '',
        msgBoxEventType: row.msgBoxEventType || '',
        msgBoxEventBody: row.msgBoxEventBody || '',
        msgBoxIconUrl: row.msgBoxIconUrl || '',
        msgBoxImageUrl: row.msgBoxImageUrl || '',
        activeMode: row.activeMode || '',
        audienceType: row.audienceType || 1,
        userTags: row.userTags ? String(row.userTags).split(',').filter(Boolean) : [],
        accountImportKey: row.accountImportKey || '',
        platformType: row.platformType ? String(row.platformType).split(',').filter(Boolean) : [],
        isAllPlatform: row.platformType ? 0 : 1,
        status: row.status !== undefined ? row.status : 1,
        daysAhead: row.daysAhead !== undefined ? row.daysAhead : null,
        expireAdvanceDays: row.expireAdvanceDays !== undefined ? row.expireAdvanceDays : null,
        onceJobApplyTime: row.onceJobApplyTime || '',
        periodJobStartTime: row.periodJobStartTime || '',
        periodJobEndTime: row.periodJobEndTime || '',
        reviewStatus: row.reviewStatus
      };
    },

    // 获取通知类型名称
    getNoticeTypeName(pushType) {
      if (!pushType) return ''
      const types = pushType.split(',').map(type => {
        switch (parseInt(type)) {
          case 1: return '消息盒子'
          case 2: return 'push提醒'
          case 3: return '短信通知'
          default: return ''
        }
      }).filter(Boolean)
      return types.join('、')
    },

    // 获取触发条件名称
    getTriggerConditionName(activeMode) {
      const conditions = {
        1: '会员开通提醒',
        2: '会员自动续费即将扣款提醒',
        3: '会员即将到期提醒',
        4: '自动续费取消提醒',
        5: '会员退款提醒',
        6: '会员活动一次性活动',
        7: '会员活动周期性活动'
      }
      return conditions[activeMode] || ''
    },

    // 获取审核状态名称
    getReviewStatusName(reviewStatus) {
      const statusMap = {
        0: '草稿',
        1: '待审核',
        2: '审核通过',
        3: '审核拒绝',
        4: '撤销审核'
      }
      return statusMap[reviewStatus] || ''
    },

    // 获取事件类型名称
    getEventTypeName(eventType) {
      const eventMap = {
        0: '无',
        1: '打开H5',
        2: '打开其他应用'
      }
      return eventMap[eventType] || ''
    },

    // 获取受众类型名称
    getAudienceTypeName(audienceType) {
      const audienceMap = {
        1: '全部用户',
        2: '指定标签',
        3: '指定用户',
        4: '前端指定用户'
      }
      return audienceMap[audienceType] || ''
    },

    // 获取平台类型名称
    getPlatformTypeNames(platformType) {
      if (!platformType) return ''
      const types = (Array.isArray(platformType) ? platformType : String(platformType).split(',')).map(type => {
        switch (parseInt(type)) {
          case 1: return 'Android'
          case 2: return 'iOS'
          case 3: return 'PC'
          case 4: return 'Mac'
          case 5: return 'Linux'
          case 6: return '小程序'
          case 7: return 'Web'
          case 8: return '鸿蒙'
          default: return ''
        }
      }).filter(Boolean)
      return types.join('、')
    },

    // 审核通过
    async handleApprove() {
      try {
        this.submitting = true

        const params = {
          bizRefrenceId: this.currentRow.id,
          status: 2, // 审核通过
          content: this.auditForm.content
        }

        const { data } = await submitExamine(params)
        if (data.code === 200) {
          Message.success('审核通过成功')
          this.dialogVisible = false
          this.$emit('audit-success')
        } else {
          Message.error(data.message || '审核失败')
        }
      } catch (error) {
        console.error('审核通过失败:', error)
        Message.error('审核失败')
      } finally {
        this.submitting = false
      }
    },

    // 审核不通过
    async handleReject() {
      try {
        await this.$refs.auditForm.validate()
        this.submitting = true

        const params = {
          bizRefrenceId: this.currentRow.id,
          status: 3, // 审核拒绝
          content: this.auditForm.content
        }

        const { data } = await submitExamine(params)
        if (data.code === 200) {
          Message.success('审核拒绝成功')
          this.dialogVisible = false
          this.$emit('audit-success')
        } else {
          Message.error(data.message || '审核失败')
        }
      } catch (error) {
        console.error('审核拒绝失败:', error)
        Message.error('审核失败')
      } finally {
        this.submitting = false
      }
    },

    // 取消
    handleCancel() {
      this.dialogVisible = false
    },

    // 关闭弹窗
    handleClose() {
      this.currentRow = {}
      this.auditForm.content = ''
      if (this.$refs.auditForm) {
        this.$refs.auditForm.resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-content {
  max-height: 500px;
  overflow-y: auto;

  .section {
    margin-bottom: 24px;

    .section-title {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 16px;
      color: #303133;
      border-bottom: 1px solid #ebeef5;
      padding-bottom: 8px;
    }

    .section-content {
      .el-form-item {
        margin-bottom: 15px;
      }

      span {
        color: #606266;
      }

      .el-image {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }
    }
  }
}

.audit-opinion {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer {
  text-align: right;
}
</style>
